import PageSection from 'components/PageSection';
import { SectionTitle } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { paths } from 'constants';
import LocalizedLink from 'components/LocalizedLink';
import Button from 'components/Button';

const EPCSolutionSectionFive = () => {
    const { t } = useTranslation('solutionEpc');
    return (
        <PageSection containerClass="py-16 md:py-32" className="border-b-1 border-neutral">
            <div className="w-full lg:w-1/2">
                <SectionTitle className="fade-in-scroll">{t('sectionFive.title')}</SectionTitle>
            </div>
            <div className="hidden md:flex md:items-center md:gap-4 lg:gap-0 mt-8">
                <LocalizedLink to={paths.contactUs}>
                    <Button element="div" className="px-2 lg:px-10">
                        {t('sectionFive.cta')}
                    </Button>
                </LocalizedLink>
            </div>
        </PageSection>
    );
};

export default EPCSolutionSectionFive;
